import { render, staticRenderFns } from "./new.countdowns.page.vue?vue&type=template&id=98f2da94&"
import script from "./new.countdowns.page.vue?vue&type=script&lang=js&"
export * from "./new.countdowns.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports